export const NAME = 'alerts';

export const ALERT_TYPE_ALERT = 'alert';
export const ALERT_TYPE_CONFIRM = 'confirm';
export const ALERT_TYPE_ONLY_CONFIRM = 'only_confirm';
